type RateTier = {
  limit: number;
  rate: number;
};

type StateRateMap = {
  [state: string]: RateTier[];
};

export function getStampRate(state: string, maxPurchasePrice: number): number {
  const rates: StateRateMap = {
    ACT: [
      { limit: 500000, rate: 0.021 },
      { limit: 1000000, rate: 0.036 },
      { limit: 2000000, rate: 0.047 },
      { limit: 5000000, rate: 0.047 },
    ],
    NSW: [
      { limit: 500000, rate: 0.036 },
      { limit: 1000000, rate: 0.041 },
      { limit: 2000000, rate: 0.048 },
      { limit: 5000000, rate: 0.057 },
    ],
    QLD: [
      { limit: 500000, rate: 0.037 },
      { limit: 1000000, rate: 0.044 },
      { limit: 2000000, rate: 0.053 },
      { limit: 5000000, rate: 0.059 },
    ],
    SA: [
      { limit: 500000, rate: 0.054 },
      { limit: 1000000, rate: 0.06 },
      { limit: 2000000, rate: 0.063 },
      { limit: 5000000, rate: 0.065 },
    ],
    VIC: [
      { limit: 500000, rate: 0.055 },
      { limit: 1000000, rate: 0.059 },
      { limit: 2000000, rate: 0.058 },
      { limit: 5000000, rate: 0.063 },
    ],
    WA: [
      { limit: 500000, rate: 0.038 },
      { limit: 1000000, rate: 0.045 },
      { limit: 2000000, rate: 0.049 },
      { limit: 5000000, rate: 0.051 },
    ],
    NT: [
      { limit: 500000, rate: 0.05 },
      { limit: 1000000, rate: 0.051 },
      { limit: 2000000, rate: 0.051 },
      { limit: 5000000, rate: 0.059 },
    ],
    TAS: [
      { limit: 500000, rate: 0.039 },
      { limit: 1000000, rate: 0.042 },
      { limit: 2000000, rate: 0.044 },
      { limit: 5000000, rate: 0.046 },
    ],
  };

  const defaultRate = 0.05;

  if (!rates[state]) return defaultRate;

  for (const tier of rates[state]) {
    if (maxPurchasePrice <= tier.limit) {
      return tier.rate;
    }
  }

  return defaultRate;
}
